import React from 'react';
import s from './ConnectModal.module.css';
import Modal from '../../../../shared/ui/modal/Modal';
import Button from '../../../../shared/ui/button/Button';
import Spinner from '../../../../shared/ui/spinner/Spinner';

interface ConnectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    provider: string;
    isLoading?: boolean;
}

const ConnectModal: React.FC<ConnectModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    provider,
    isLoading = false,
}) => {
    if (!isOpen) return null;

    const getProviderName = (provider: string) => {
        const names: { [key: string]: string } = {
            facebook: 'Facebook',
            instagram: 'Instagram',
            linkedin: 'LinkedIn',
            pinterest: 'Pinterest',
            threads: 'Threads',
            tiktok: 'TikTok',
            twitter: 'Twitter',
            youtube: 'YouTube',
        };
        return names[provider] || provider;
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} width="400px">
            {isLoading ? (
                <div className={s.modal}>
                    <h3 className={s.title}>Connecting...</h3>
                    <Spinner />
                </div>
            ) : (
                <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                    <h3 className={s.title}>Do you want to connect {getProviderName(provider)}?</h3>
                    <p className={s.subtitle}>
                        This action will connect your {getProviderName(provider)} to SimpleCreate.
                    </p>
                    <div className={s.buttons}>
                        <Button onClick={onClose} text="Cancel" />
                        <Button
                            onClick={onConfirm}
                            text="Connect"
                            style={{ backgroundColor: '#FFDD35', color: 'black' }}
                        />
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default ConnectModal;
